'use client';

import React, { useState, useMemo, useEffect } from 'react';

import { ThemeEnum, ThemeType } from './_themes';

import ThemeContext from './_context';

import useTheme from './hooks/useTheme';
import useThemeContext from './hooks/useThemeContext';

import { ThemeProps } from './_props';

/**
 * Theme Provider
 */

function ThemeProvider({ children, theme = 'Blog' }: ThemeProps) {
  const [currentTheme, setCurrentTheme] = useState<ThemeType>(ThemeEnum[theme]);

  const themeConfig = useMemo(
    () => ({
      currentTheme,
      setCurrentTheme,
    }),
    [currentTheme, setCurrentTheme],
  );

  useEffect(() => {
    setCurrentTheme(ThemeEnum[theme]);
  }, [theme, setCurrentTheme]);

  return <ThemeContext.Provider value={themeConfig}>{children}</ThemeContext.Provider>;
}

/**
 * Exports
 */

export default ThemeProvider;

export { ThemeEnum, useThemeContext, useTheme };
export type { ThemeType };
